import React, { useState } from "react";
import DOMPurify from "dompurify";
import Grid from "@mui/material/Grid";

const About = ({ name, profileDetailsExtended, teamPicture }) => {
    // Show more/less logic for both sections
    const [showMoreAbout, setShowMoreAbout] = useState(false);
    const [showMoreWhy, setShowMoreWhy] = useState(false);
    const aboutText = profileDetailsExtended?.about || "";
    const whyText = profileDetailsExtended?.whyChoose || "";
    // For HTML content, length check is less meaningful, but keep for compatibility
    const aboutLong = aboutText.replace(/<[^>]+>/g, '').length > 1000;
    const whyLong = whyText.replace(/<[^>]+>/g, '').length > 1000;

    // Use same mobile check as in OurTechnology.js
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;

    // Helper to safely render HTML using DOMPurify
    const renderHtml = (html) => (
        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />
    );

    return (
        <Grid container style={{ padding: isMobile ? '60px 30px' : '60px 60px' }}>
            <Grid size={12}>
                <h3 style={{ margin: 0, marginBottom: 20, fontSize: '26px' }}>Installer overview</h3>
            </Grid>
            <Grid container size={12} spacing={3}>
                <Grid size={teamPicture && !isMobile ? { xs: 12, md: 6 } : 12} style={{ minWidth: 0 }}>
                    <div style={{ margin: 0, marginBottom: 30, overflowWrap: 'break-word', wordBreak: 'break-word', overflow: 'hidden' }}>
                        {aboutLong && !showMoreAbout
                            ? renderHtml(aboutText.slice(0, 1000) + '...')
                            : renderHtml(aboutText)}
                        {aboutLong && (
                            <span
                                style={{ color: '#229626', cursor: 'pointer', marginLeft: 8, fontWeight: 600 }}
                                onClick={() => setShowMoreAbout((v) => !v)}
                            >
                                {showMoreAbout ? 'Show less' : 'Show more'}
                            </span>
                        )}
                    </div>
                </Grid>
                {teamPicture && (
                    <Grid size={isMobile ? 12 : { xs: 12, md: 6 }} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <div style={{
                            position: 'relative',
                            width: '100%',
                            maxWidth: 500,
                            paddingTop: '56.25%'
                        }}>
                            <img
                                src={teamPicture}
                                alt="Team"
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '6px'
                                }}
                            />
                        </div>
                    </Grid>
                )}
            </Grid>
            <Grid size={12}>
                <h3 style={{ margin: 0, marginBottom: 20, fontSize: '26px' }}>Why choose {name}?</h3>
            </Grid>
            <Grid size={12}>
                <div style={{ margin: 0, overflowWrap: 'break-word', wordBreak: 'break-word', overflow: 'hidden' }}>
                    {whyLong && !showMoreWhy
                        ? renderHtml(whyText.slice(0, 1000) + '...')
                        : renderHtml(whyText)}
                    {whyLong && (
                        <span
                            style={{ color: '#229626', cursor: 'pointer', marginLeft: 8, fontWeight: 600 }}
                            onClick={() => setShowMoreWhy((v) => !v)}
                        >
                            {showMoreWhy ? 'Show less' : 'Show more'}
                        </span>
                    )}
                </div>
            </Grid>
        </Grid>
    );
};

export default About;
